export const partnersTranslation = {
  en: {
    "S.No": "S.No",
    Name: "Name",
    Logo: "Logo",
    Status: "Status",
    "Created At": "Created At",
    Actions: "Actions",
    Home: "Home",
    Settings: "Settings",
    Landing: "Landing",
    Partners: "Partners",
    "+ Add Partner": "+ Add Partner",
    "Search by name...": "Search by name...",
    "Name (EN)": "Name (EN)",
    "Name (AR)": "Name (AR)",
    Active: "Active",
    Inactive: "Inactive",
    "Edit Partner": "Edit Partner",
    "Add New Partner": "Add New Partner",
    "Update Partner": "Update Partner",
    "Add Partner": "Add Partner",
    "Are you sure you want to delete partner '{{name}}'?":
      "Are you sure you want to delete partner '{{name}}'?",
    Cancel: "Cancel",
    Delete: "Delete",
    "This action cannot be undone.": "This action cannot be undone.",
    "N/A": "N/A",
  },
  ar: {
    "S.No": "رقم",
    Name: "الاسم",
    Logo: "الشعار",
    Status: "الحالة",
    "Created At": "تاريخ الإنشاء",
    Actions: "الإجراءات",
    Home: "الصفحة الرئيسية",
    Settings: "الإعدادات",
    Landing: "الموقع التعريفي",
    Partners: "الشركاء",
    "+ Add Partner": "+ إضافة شريك",
    "Search by name...": "البحث حسب الاسم...",
    "Name (EN)": "الاسم (EN)",
    "Name (AR)": "الاسم (AR)",
    Active: "نشط",
    Inactive: "غير نشط",
    "Edit Partner": "تعديل الشريك",
    "Add New Partner": "إضافة شريك جديد",
    "Update Partner": "تحديث الشريك",
    "Add Partner": "إضافة شريك",
    "Are you sure you want to delete partner '{{name}}'?":
      "هل أنت متأكد أنك تريد حذف الشريك '{{name}}'؟",
    Cancel: "إلغاء",
    Delete: "حذف",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
    "N/A": "غير متوفر",
  },
};
